const CSP_ERROR_MESSAGE = 'Failed to fetch';
const LOCALHOST = 'localhost';
const CSP_INSTRUCTIONS = 'We noticed you had CSP errors while loading a local MF. Please refer to this guide: https://trident.monday.beer/docs/frontend/getting-started/develop-mf#working-with-a-remote-host';
const LOCALHOST_RESOURCE_REGEX = /https?:\/\/localhost/;
function isCspErrorForResource(error, failedResourceUrl) {
    const isCspError = typeof error === 'object' && error.message === CSP_ERROR_MESSAGE;
    if (!isCspError) {
        return false;
    }
    const isLocalhostRequest = LOCALHOST_RESOURCE_REGEX.test(failedResourceUrl);
    const isLocalhostHost = window.location.hostname === LOCALHOST;
    return isLocalhostRequest && !isLocalhostHost;
}
function showCspErrorInstructions() {
    // eslint-disable-next-line no-console
    console.log(`
======================
${CSP_INSTRUCTIONS}
======================
`);
    // eslint-disable-next-line no-alert
    alert(CSP_INSTRUCTIONS);
}

export { isCspErrorForResource, showCspErrorInstructions };
